import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let Thumbnail = class Thumbnail extends Vue {
    constructor() {
        super(...arguments);
        this.customLogo = this.$store.state.customLogoURL;
    }
    get style() {
        let style = '';
        if (this.src) {
            style += `background-image: url('${this.src}');`;
        }
        return style;
    }
};
__decorate([
    Prop({ default: '' })
], Thumbnail.prototype, "src", void 0);
Thumbnail = __decorate([
    Component
], Thumbnail);
export default Thumbnail;
